(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/views/play/game-picker.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/views/play/game-picker.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.views.GamePicker = Marionette.CollectionView.extend({
    childView: svs.bingo.views.GamePromo,
    viewFilter: function(childView) {
      return childView.model.get('id') !== this.options.gameId;
    },

    onSetPreventUpdate: function(state) {
      this.children.each(function(view) {
        view.triggerMethod('setPreventUpdate', state);
      });
    }
  });
})(Backbone, _, svs);


 })(window);